// BookDetailPage.tsx
// Compatibility entrypoint for the Book Detail feature.
// NOTE: Update frontend/src/__tests__/BookDetailPage.test.tsx and run
// `../scripts/test-frontend.sh BookDetailPage` when editing helper logic or behaviors covered there.
import React from 'react';
import { useParams } from 'react-router-dom';
import BookDetailPageContainer from './bookDetail/BookDetailPageContainer';
import { TranslationStatusProvider } from './TranslationStatusContext';

export {
  MIN_LOCK_ESTIMATE_MINUTES,
  buildOptimisticTranslationStatus,
  computeTranslationEstimatedMinutes,
  ensureMinimumLockEstimate,
  estimateExportMinutes,
  filterActiveChapterEditLocks,
  hasPendingProofreadReviewForRow,
  isRelationshipAnalysisAlreadyInProgressMessage,
  normalizeEditingNotesResponse,
  normalizeProofreadRequestStatus,
  reconcileProofreadOptimisticTranslation,
  resolveChapterEditLockState,
  resolveExportFilename,
  shouldOverwriteBulkProofreadForRow,
  shouldQueueBulkRelationshipAnalysis,
  shouldSubmitBulkProofreadForRow,
  shouldSuppressProofreadAggregateToast,
  summarizeBulkProofreadApplyResult,
  summarizeProofreadCompletionStatuses,
  translatedChapterNeedsProofreadHydration,
} from './bookDetail/utils/bookDetailProgressUtils';

export {
  buildBulkTranslationRequestPayload,
  buildTranslationRequestPayload,
  runBulkTermScanAutoRunPreflight,
} from './bookDetail/utils/bookDetailTermScanUtils';

export {
  buildFrenchDialogueRetranslationTopUpContext,
  deriveFrenchDialogueRetranslationUiState,
} from './bookDetail/utils/bookDetailFrenchDialogueUtils';

const BookDetailPage: React.FC = () => {
  const { bookId, bookGuid } = useParams<{ bookId?: string; bookGuid?: string }>();
  const resolvedBookId = (bookId || bookGuid || '').trim();

  if (!resolvedBookId) {
    return <div>No book ID provided</div>;
  }

  return (
    <TranslationStatusProvider bookId={resolvedBookId}>
      <BookDetailPageContainer bookId={resolvedBookId} />
    </TranslationStatusProvider>
  );
};

export default BookDetailPage;
